import { render, staticRenderFns } from "./AddressMain.vue?vue&type=template&id=17e2dace&scoped=true&"
import script from "./AddressMain.vue?vue&type=script&lang=js&"
export * from "./AddressMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2dace",
  null
  
)

export default component.exports